"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInterval = void 0;
var _react = require("react");
/**
 * Run a function periodically via `window.setInterval`.
 * See https://overreacted.io/making-setinterval-declarative-with-react-hooks
 * `callback` is the function to call every 'delay' milliseconds.
 * `stopTest` is an optional function that will stop the interval if it returns true.
 * `delay` is the time to wait between calling `callback`. If `delay` is set to null, the interval is paused.
 */
const useInterval = _ref => {
  let {
    callback,
    stopTest = null,
    delay = 1000,
    maxTries = 3
  } = _ref;
  const savedCallback = (0, _react.useRef)();
  const tryCount = (0, _react.useRef)(0);
  const intervalId = (0, _react.useRef)(0);
  const stopTestFunction = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    savedCallback.current = callback;
    stopTestFunction.current = stopTest;
  }, [callback, stopTest]);
  (0, _react.useEffect)(() => {
    function tick() {
      var _stopTestFunction$cur;
      tryCount.current++;
      if (tryCount.current >= maxTries || (_stopTestFunction$cur = stopTestFunction.current) !== null && _stopTestFunction$cur !== void 0 && _stopTestFunction$cur.call(stopTestFunction)) {
        clearInterval(intervalId === null || intervalId === void 0 ? void 0 : intervalId.current);
      } else {
        var _savedCallback$curren;
        (_savedCallback$curren = savedCallback.current) === null || _savedCallback$curren === void 0 ? void 0 : _savedCallback$curren.call(savedCallback);
      }
    }
    if (delay !== null) {
      var _savedCallback$curren2;
      (_savedCallback$curren2 = savedCallback.current) === null || _savedCallback$curren2 === void 0 ? void 0 : _savedCallback$curren2.call(savedCallback); // Run once immediately.
    }
    if (delay !== null && callback !== null) {
      intervalId.current = window.setInterval(tick, delay);
      return () => clearInterval(intervalId.current);
    }
    return () => {};
  }, [delay]); // eslint-disable-line react-hooks/exhaustive-deps
};
exports.useInterval = useInterval;